import { render, staticRenderFns } from "./RequiredNotice.vue?vue&type=template&id=11d2dc02&"
import script from "./RequiredNotice.vue?vue&type=script&lang=js&"
export * from "./RequiredNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports